<template>
  <section class="dedicatoria-section" ref="sectionRef">
    <!-- Contenedor Principal -->
    <div class="tarjeta-dedicatoria" ref="cardRef">
      <!-- Decoración superior elegante -->
      <div class="adorno-superior"></div>

      <!-- Frase emotiva -->
      <p class="frase-principal" ref="textRef">
        La pequeña princesa que un día soñó con su cuento de hadas, hoy celebra sus XV años.
      </p>

      <!-- Foto rectangular tipo marco/polaroid -->
      <div class="contenedor-foto" ref="photoRef">
        <div class="marco-polaroid">
          <img src="@/assets/ChatGPT Image 15 sept 2026, 02_01_17.png" alt="Princesa de pequeña" class="foto-chiquita" />
        </div>
      </div>

      <!-- Decoración inferior elegante -->
      <div class="adorno-inferior"></div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DedicatoriaPrincesa',
  setup() {
    const sectionRef = ref(null)
    const cardRef = ref(null)
    const textRef = ref(null)
    const photoRef = ref(null)

    onMounted(async () => {
      await nextTick()

      if (!sectionRef.value) return

      // Línea de tiempo con ScrollTrigger para la entrada al viewport
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.value,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        }
      })

      // 1. Aparición elegante de la tarjeta contenedora principal
      tl.fromTo(
        cardRef.value,
        { opacity: 0, y: 40, scale: 0.95 },
        { opacity: 1, y: 0, scale: 1, duration: 0.9, ease: 'power3.out' }
      )
      // 2. Revelado de la frase
      .fromTo(
        textRef.value,
        { opacity: 0, y: 15 },
        { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out' },
        '-=0.5'
      )
      // 3. Entrada triunfal del marco rectangular con una rotación sutil y elegante
      .fromTo(
        photoRef.value,
        { opacity: 0, scale: 0.9, rotate: 3, y: 20 },
        { opacity: 1, scale: 1, rotate: 0, y: 0, duration: 0.9, ease: 'back.out(1.3)' },
        '-=0.4'
      )
    })

    return {
      sectionRef,
      cardRef,
      textRef,
      photoRef
    }
  }
}
</script>

<style scoped>
/* ==================== CONTENEDOR GENERAL ==================== */
.dedicatoria-section {
  width: 100%;
  max-width: 850px;
  margin: 0 auto;
  padding: 50px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ==================== RECUADRO PRINCIPAL ==================== */
.tarjeta-dedicatoria {
  position: relative;
  width: 100%;
  background: #f0c9d3;
  background-image: 
    linear-gradient(135deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.05)),
    linear-gradient(180deg, #f5b9c9, #e8aebf);
  border-radius: 24px;
  padding: 45px 30px;
  text-align: center;
  box-shadow: 
    0 15px 35px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 2px solid rgba(255, 255, 255, 0.6);
  will-change: transform, opacity;
}

/* Adornos en los bordes */
.adorno-superior, .adorno-inferior {
  width: 50px;
  height: 2px;
  background: #ffffff;
  opacity: 0.8;
  margin: 0 auto;
  border-radius: 2px;
}
.adorno-superior { margin-bottom: 25px; }
.adorno-inferior { margin-top: 25px; }

/* ==================== FRASE ESTILIZADA ==================== */
.frase-principal {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.4rem, 4vw, 1.9rem);
  color: #2e2630;
  line-height: 1.5;
  margin: 0 auto 30px;
  max-width: 650px;
  font-style: italic;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
}

/* ==================== FOTO RECTANGULAR TIPO MARCO / POLAROID ==================== */
.contenedor-foto {
  width: 100%;
  max-width: 500;
  height: 300px;
  margin: 0 auto;
  will-change: transform, opacity;
}

.marco-polaroid {
  background: #ffffff;
  padding: 12px 12px 36px 12px; /* Margen inferior simulando estilo polaroid clásica */
  border-radius: 12px;
  box-shadow: 
    0 12px 30px rgba(0, 0, 0, 0.12),
    0 2px 6px rgba(0, 0, 0, 0.04);
  transform: rotate(-1.5deg); /* Le da un toque muy orgánico y natural */
  transition: transform 0.3s ease;
}

.marco-polaroid:hover {
  transform: rotate(0deg) scale(1.02);
}

.foto-chiquita {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
  border-radius: 6px;
}

/* ==================== RESPONSIVO FINO ==================== */
@media (max-width: 480px) {
  .tarjeta-dedicatoria {
    padding: 35px 20px;
    border-radius: 18px;
  }
  .marco-polaroid {
    padding: 10px 10px 30px 10px;
  }
  .foto-chiquita {
    height: 190px;
  }
}
</style>